import React, { useState, useCallback, useEffect, useMemo, memo } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useNavigate } from 'react-router-dom';
import { TouchableButton } from '@components/common/Touchable/index';
import { APP_CONFIG, COUNTRY_CODE } from '@constants';
import countryCodes from '@constants/countryCodes.json';
import { flowType } from '@utility/userInfo';
import { getObjectValue } from '@utility/utills';
import { getFormatedPhoneNumber } from '@utility/helperFunction';
import { setCurrentPage, removeSeat, clearCart, checkVoid } from '@reducers/orders';
import { setErrorPopUp } from '@reducers/notification';
import { updateChecksAfterResponse } from '@reducers/storeChecks';
import { addInProcessItemsToCart } from '../../../MenuOrderHandler';
import { LABEL } from '@veriables';
import style from '../../../MenuCartBarV2/MenuCartBarHeader/MenuCartBarHeader.module.scss';
import SpeedOrderCancelationModal from '@components/OrderController/Modals/SpeedOrderCancelation';
import FullWidthModal from '@components/common/Modal/FullWidthModal';
import ModalHeader from '@components/common/ModalHeader/index';
import OpenCheckPopUp from '@components/storeChecks/openCheckPopUp/indexCopy';
import styles from './DriveThruContentHeader.module.scss';

const countryCodeMap = new Map(countryCodes.map(c => [c.dialCode, c]));

const DriveThruContentHeader = ({ 
  check, 
  serverAppTheme, 
  deviceInfo, 
  auth, 
  userInfo, 
  setCurrentPage, 
  removeSeat, 
  clearCart, 
  cart, 
  setErrorPopUp, 
  checkVoid, 
  updateChecksAfterResponse 
}) => {
  const navigate = useNavigate();
  const flowTypeValue = useMemo(() => flowType(), []);

  const inputFields = useMemo(() => deviceInfo?.deviceGroup?.inputFields, [deviceInfo?.deviceGroup]);
  const isNameEnabled = useMemo(() => inputFields?.nameEnabled ?? true, [inputFields]);
  const isNameRequired = useMemo(() => inputFields?.nameRequired ?? false, [inputFields]);
  const isPhoneEnabled = useMemo(() => inputFields?.phoneNumberEnabled ?? true, [inputFields]);

  const defaultCountryCode = useMemo(
    () => getObjectValue(() => COUNTRY_CODE[auth.country].dialCode, '1'),
    [auth?.country]
  );
  const phoneNumberMaxLength = useMemo(
    () => getObjectValue(() => COUNTRY_CODE[auth.country].maxLength, 10),
    [auth?.country]
  );
  const [countryCode, setCountryCode] = useState(defaultCountryCode);

  const phonePrefix = useMemo(() => {
    const entry = countryCodeMap.get(countryCode);
    return entry ? `${entry.code} (+${entry.dialCode})` : `(+${countryCode})`;
  }, [countryCode]);
const seatsData = useMemo(
      () => JSON.parse(window.sessionStorage.getItem('seat')),
      []
    );
  const [name, setName] = useState(window.sessionStorage.getItem('counterName') || '');
  const [phone, setPhone] = useState(window.sessionStorage.getItem('counterPhone') || '');
  const [openPopup, setOpenPopup] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    setOpenPopup(null);
    setName('');
    setPhone('');
    window.sessionStorage.removeItem('counterName');
    window.sessionStorage.removeItem('counterPhone');
    window.sessionStorage.removeItem('counterCountry');
  }, [check?.id]);

  useEffect(() => {
    const validateNameBeforeFinalize = () => {
      const savedName = window.sessionStorage.getItem('counterName');
      const savedPhone = window.sessionStorage.getItem('counterPhone');
      
      if (isNameRequired && isNameEnabled && (!savedName || !savedName.trim())) {
        setOpenPopup('name');
        return { isValid: false, errorType: 'name' };
      }
      
      if (inputFields?.phoneNumberRequired && isPhoneEnabled && (!savedPhone || !savedPhone.trim())) {
        setOpenPopup('phone');
        return { isValid: false, errorType: 'phone' };
      }
      
      return { isValid: true };
    };

    window.driveThruNameValidation = {
      validateAndOpenModal: validateNameBeforeFinalize,
      openModal: () => setOpenPopup('name'),
    };

    return () => {
      delete window.driveThruNameValidation;
    };
  }, [isNameRequired, isNameEnabled, isPhoneEnabled, inputFields?.phoneNumberRequired]);

  const handleCountryCodeChange = useCallback(event => {
    setCountryCode(event.id);
  }, []);

  const validateTabName = useCallback(value => {
    return new Promise((resolve, reject) => {
      const isNameEmpty = !value.tabName || !value.tabName.trim();
      if (isNameRequired && isNameEnabled && isNameEmpty) {
        reject(new Error('Name is required'));
      } else {
        resolve({ isCheckModalOpenFlag: false, value });
      }
    });
  }, [isNameRequired, isNameEnabled]);

  const onModalSubmit = useCallback(value => {
    window.sessionStorage.setItem('counterName', value.tabName || '');
    window.sessionStorage.setItem('counterPhone', value.phoneNumber || '');
    window.sessionStorage.setItem('counterCountry', countryCode);
    setName(value.tabName || '');
    setPhone(value.phoneNumber || '');
    setOpenPopup(null);
  }, [countryCode]);

 

  const handleCloseClick = useCallback(() => {
    setShowConfirm(true);
  }, []);

  const checkNumber = useMemo(
    () => check?.number ?? (JSON.parse(window.sessionStorage.getItem('seat') || 'null'))?.number,
    [check?.number]
  );
 const onCloseModal = useCallback(() => {
    setOpenPopup(null);
  }, []);
  const namePlaceholder = useMemo(
    () => `${LABEL().DT_ENTER_NAME} (${isNameRequired ? LABEL().REQUIRED : LABEL().OPTIONAL})`,
    [isNameRequired]
  );
  const phonePlaceholder = useMemo(
    () => inputFields?.phoneNumberRequired
      ? `${LABEL().ENTER_PHONE_NUMBER} (${LABEL().REQUIRED})`
      : `${LABEL().ENTER_PHONE_NUMBER} (${LABEL().OPTIONAL})`,
    [inputFields?.phoneNumberRequired]
  );

  const formattedPhone = useMemo(() => getFormatedPhoneNumber(phone), [phone]);

  const displayName = useMemo(() => {
    if (!name) return namePlaceholder;
    return name.length > 19 ? `${name.slice(0, 19)}...` : name;
  }, [name, namePlaceholder]);

  const noopManagerCheck = useCallback(() => {}, []);

  const popupDeviceGroup = useMemo(() => ({
    ...deviceInfo?.deviceGroup,
    inputFields: {
      ...inputFields,
      nameEnabled: isNameEnabled,
      phoneNumberEnabled: inputFields?.phoneNumberEnabled,
      phoneNumberRequired: inputFields?.phoneNumberRequired,
    },
  }), [deviceInfo?.deviceGroup, inputFields, isNameEnabled]);

  return (
    <div
      style={{ height: '40px' }}
      className="row w-95 d-flex p-0 m-0 align-items-start fs-16 fw-600"
    >

      {isNameEnabled && (
        <div
          className={cn(
            'w-40 px-2 mr-2  d-flex justify-content-center align-items-center py-1',
            styles.inputBox
          )}
          onClick={() => setOpenPopup('name')}
        >
          <div className={cn("w-100 fs-16 fw-400 px-2", styles.sameRow)}
          >
            {displayName}
          </div>
        </div>
      )}

      {isPhoneEnabled && (
        <div
          className={cn(
            'w-50 mr-2 px-2 position-relative d-flex justify-content-center align-items-center py-1',
            styles.inputBox
          )}
          onClick={() => setOpenPopup('phone')}
        >
          <div className="mr-1">{phonePrefix}</div>
          <div className='fs-16 fw-400'>{formattedPhone || phonePlaceholder}</div>
        </div>
      )}

      {openPopup && (
        <FullWidthModal
          isOpen
          style={{ backgroundColor: serverAppTheme?.popUp_bg, height: '100%' }}
          customClass="h-100"
          customClass2="h-100 w-100"
        >
          <div className="col-12 justify-content-center align-items-center position-relative text-center p-0">
            <ModalHeader
               isTab={seatsData?.tab}
              stationName={seatsData?.stationName}
              tileHeader={LABEL().DT_ENTER_NAME}
              seatNumber={seatsData?.number}
            />
            <div className="mb-0">
              <OpenCheckPopUp
                type="text"
                name="tabName"
                isCounter
                placeholder={namePlaceholder}
                isOpen={!!openPopup}
                validate={validateTabName}
                onSubmit={onModalSubmit}
                hideGuestCount
                countryCode={countryCode}
                isMenuTop
                deviceGroup={popupDeviceGroup}
                handleCountryCodeChange={handleCountryCodeChange}
                phoneNumberMaxLength={phoneNumberMaxLength}
                onCloseTable={onCloseModal}
                serverAppTheme={serverAppTheme}
                setErrorPopUp={setErrorPopUp}
                isDriveThru={true}
                openManagerCheck={noopManagerCheck}
              />
            </div>
          </div>
        </FullWidthModal>
      )}

      {showConfirm && (
        <SpeedOrderCancelationModal
          cancelOrderConfirm={showConfirm}
          setCancelOrderConfirm={setShowConfirm}
          goToChecks={handleClose}
          serverAppTheme={serverAppTheme}
        />
      )}
    </div>
  );
};

const mapStateToProps = ({ orders, theme, oauth }) => ({
  check: orders.seats,
  serverAppTheme: theme.serverAppTheme,
  cart: orders.cart,
  deviceInfo: oauth.deviceInformation,
  auth: oauth.authInfo,
  userInfo: oauth.loggedInUserData,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ 
    setCurrentPage, 
    removeSeat, 
    clearCart, 
    setErrorPopUp, 
    checkVoid, 
    updateChecksAfterResponse 
  }, dispatch);

const MemoizedHeader = React.memo(DriveThruContentHeader);

export default connect(mapStateToProps, mapDispatchToProps)(MemoizedHeader);